import values from '../values/values';
import { GRAPH_WORK_COLORS } from './graphMultiWorkUtils';

export const ERRO_TRACE_COLOR = '#e53935';

function coordHasErro(item, erroCodigo) {
    const erros = item?.erros_ativos;
    return Array.isArray(erros) && erros.includes(erroCodigo);
}

export function buildLinhasForErroTrabalho(histCoords, erroCodigo, color = ERRO_TRACE_COLOR) {
    if (!erroCodigo || !Array.isArray(histCoords) || histCoords.length === 0) {
        return { linhas: [], savedPoints: [] };
    }

    const linhas = [];
    const savedPoints = [];
    let segmentoAtual = [];

    const flushSegmento = () => {
        if (segmentoAtual.length >= 2) {
            linhas.push({ path: segmentoAtual, color });
        } else if (segmentoAtual.length === 1) {
            savedPoints.push({ ...segmentoAtual[0], color });
        }
        segmentoAtual = [];
    };

    histCoords.forEach((item, index) => {
        if (item?.lat == null || item?.lng == null) {
            return;
        }

        if (index > 0) {
            const lastPoint = histCoords[index - 1];
            if (lastPoint?.lat != null && lastPoint?.lng != null) {
                const distance = values.distanceBetweenpointsM(
                    lastPoint.lat,
                    lastPoint.lng,
                    lastPoint.alt,
                    item.lat,
                    item.lng,
                    item.alt
                );
                if (distance > 20 && segmentoAtual.length > 0) {
                    flushSegmento();
                }
            }
        }

        if (coordHasErro(item, erroCodigo)) {
            segmentoAtual.push({
                lat: parseFloat(item.lat),
                lng: parseFloat(item.lng),
            });
        } else if (segmentoAtual.length > 0) {
            flushSegmento();
        }
    });

    if (segmentoAtual.length > 0) {
        flushSegmento();
    }

    return { linhas, savedPoints };
}

/**
 * Monta traçados de erro para vários trabalhos, cada um com cor própria.
 * worksEntries: [{ id, histCoords, color? }, ...]
 */
export function buildMultiWorkErroLinhas(worksEntries, erroCodigo) {
    const linhas = [];
    const savedPoints = [];
    const legend = [];

    if (!erroCodigo || !Array.isArray(worksEntries)) {
        return { linhas, savedPoints, legend };
    }

    worksEntries.forEach((entry, index) => {
        const color = entry.color || GRAPH_WORK_COLORS[index % GRAPH_WORK_COLORS.length];
        legend.push({
            id: entry.id,
            label: entry.id != null ? `#${entry.id}` : `Trabalho ${index + 1}`,
            color,
        });
        const built = buildLinhasForErroTrabalho(entry.histCoords, erroCodigo, color);
        linhas.push(...built.linhas);
        savedPoints.push(...built.savedPoints);
    });

    return { linhas, savedPoints, legend };
}

export function getCenterFromLinhas(linhas, fallbackCenter = null, savedPoints = []) {
    if (Array.isArray(savedPoints) && savedPoints.length > 0) {
        const point = savedPoints[savedPoints.length - 1];
        return { lat: point.lat, lng: point.lng };
    }

    if (!Array.isArray(linhas) || linhas.length === 0) {
        return fallbackCenter;
    }

    const lastLinha = linhas[linhas.length - 1];
    const lastPoint = lastLinha?.path?.[lastLinha.path.length - 1];
    if (!lastPoint) {
        return fallbackCenter;
    }

    return { lat: lastPoint.lat, lng: lastPoint.lng };
}
